import { getAllCompliances, getComplianceDetails, cdnLoader, getMenuByName, AppContext, handlePageNotFound} from '@monorepo-nx/std-watch/services';
import { useRouter } from 'next/router';
import React, { useContext } from 'react';
import { RichText } from '@graphcms/rich-text-react-renderer';
import { Loader, Layout } from '@monorepo-nx/std-watch/ui';


const Compliance = ({ compliance, mainMenu }) => {
  const router = useRouter();
 

  if (router.isFallback) {
    return <Loader />;
  }
  return (
    <Layout mainMenu={mainMenu}>
      <div className=" max-w-8xl break-words mx-auto my-8">
        <div className=" bg-white px-8 md:px-16 pb-10 ">
          <div className="prose max-w-none  prose-td:px-4  prose-td:border prose-td:border-black  prose-tr:space-x-3 prose-li:marker:text-black prose-a:text-indigo-500 hover:prose-a:text-indigo-600 ">
            <RichText
              loader={cdnLoader}
              renderers={{
                h2: ({ children }) => <h2 className="text-xl mb-12">{children}</h2>,
                p: ({ children }) => <p className="my-8 ">{children}</p>
              }}
              content={compliance.content.raw.children}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default Compliance;



// Fetch data at build time
export async function getStaticProps({ params }) {
  const compliance = await getComplianceDetails(params.slug);
  const url = `/${params.slug}`
  if (!compliance) {
      return handlePageNotFound({ url })
  }
  const  mainMenuData  = await getMenuByName("Main");
  const  footerData  = await getMenuByName("Footer");

  return {
    props: {
      compliance,
      mainMenu: mainMenuData.content,
      footer: footerData.content,
    }
  };
}

// Specify dynamic routes to pre-render pages based on data.
// The HTML is generated at build time and will be reused on each request.
export async function getStaticPaths() {
  const compliances = await getAllCompliances();
  return {
    paths: compliances.map((slug) => ({ params: slug })),
    fallback: 'blocking',
  };
}